import { Loader2, Zap } from "lucide-react";

type ButtonContentOptions = {
  isLoading: boolean;
  hasCredits: boolean;
  actionText: "Generate" | "Edit Artwork";
  loadingText?: string;
};

export function getGenerateButtonContent({
  isLoading,
  hasCredits,
  actionText,
  loadingText
}: ButtonContentOptions) {
  if (isLoading) {
    return (
      <>
        <Loader2 className="size-4 animate-spin" />
        {loadingText || `${actionText}...`}
      </>
    );
  }

  if (!hasCredits) {
    return (
      <>
        <Zap className="size-4 fill-white opacity-50" />
        No Credits Remaining
      </>
    );
  }

  return (
    <>
      <Zap className="size-4 fill-white" />
      {actionText}
    </>
  );
}
